export class NotForNationalError extends Error {
  defaultMessage = 'Article non disponible pour le national'

  constructor(message = 'Article non disponible pour le national') {
    super(message)
    Object.setPrototypeOf(this, NotForNationalError.prototype)
  }
}
